module.exports = __webpack_public_path__ + "static/img/fish16.03ea0c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/starfish/fish16.png
// module id = rN3m
// module chunks = 0